var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "local-store" },
    [
      _vm.logoSrc
        ? _c("img", {
            staticClass: "local-store__logo",
            attrs: { alt: _vm.store.retailerName, src: _vm.logoSrc }
          })
        : _vm._e(),
      _c("div", { staticClass: "local-store__address body--xs" }, [
        _vm._v(_vm._s(_vm.store.retailerAddress))
      ]),
      _c(
        "div",
        { staticClass: "local-store__availability body--xs" },
        [
          _vm.store.availability !== "hidden"
            ? _c("icon", {
                staticClass: "local-store__stock-icon",
                attrs: {
                  name: _vm.store.availability ? "check" : "close",
                  size: "14px"
                }
              })
            : _vm._e(),
          _c("span", [_vm._v(_vm._s(_vm.stockText))])
        ],
        1
      ),
      _c("div", { staticClass: "local-store__price body--xs" }, [
        _vm.store.price
          ? _c("span", [_vm._v("$" + _vm._s(_vm.store.price))])
          : _vm._e()
      ]),
      _c("v-button", {
        staticClass: "btn--shop-now",
        attrs: {
          htmlTag: "a",
          href: _vm.store.shopNowUrl,
          label: _vm.buttonText,
          target: "_blank",
          rel: "noopener",
          primary: ""
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }